import {Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography} from "@mui/material";

interface MicPermissionDialogProps {
    open: boolean;
    onClose: () => void;
}

export const MicPermissionDialog: React.FC<MicPermissionDialogProps> = ({open, onClose}) => (
    <Dialog open={open} onClose={onClose}>
        <DialogTitle>Microfoontoegang geblokkeerd</DialogTitle>
        <DialogContent dividers>
            <Typography gutterBottom sx={{ pt: '16px'}}>
                Toegang tot de microfoon voor deze site is geblokkeerd. Volg de onderstaande stappen om deze in te
                schakelen:
            </Typography>
            <Typography component="ol" sx={{pb: '24px', pt: '16px'}}>
                <li>
                    Klik op het slot-icoon links van de adresbalk.
                </li>
                <li>
                    Kies <strong>Site-instellingen</strong>.
                </li>
                <li>
                    Zoek in de lijst naar <strong>Microfoon</strong> en stel in op <em>Toestaan</em>.
                </li>
                <li>
                    Herlaad deze pagina om de instellingen toe te passen.
                </li>
            </Typography>
        </DialogContent>
        <DialogActions>
            <Button onClick={onClose}>Sluiten</Button>
        </DialogActions>
    </Dialog>
);
